import React, { useEffect, useState } from 'react'
import { Container, Form, Col, Row } from 'react-bootstrap'
import { UploadAttendanceFileApi } from './attendanceAction'
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import _ from "lodash";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';


const AttendanceUpload = (props) => {
    const [attendanceFile, setAttendanceFile] = useState("");
    const [financialMonth, setFinancialMonth] = useState("");
    const [selectedMonth, setSelectedMonth] = useState(null);


    const SaveAttendanceFile = (a) => {
        props.UploadAttendanceFileApi({
            attendanceFile: attendanceFile,
            attendanceMonthYear: financialMonth
        },
            showSuccessAlert,
            showErrorAlert,
        );
    };

    const handleMonthChange = (date) => {
        const monthName = moment(date).format('YYYY-MM');
        setSelectedMonth(date);
        setFinancialMonth(monthName)
    };

    useEffect(() => {
        props.setHeading("Upload Attendance")
    }, []);

    return (
        <>
            {(props.isUploadingAttendanceFile) ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana" >
                                <Form.Label><b>Upload Attendance File *</b></Form.Label>
                                <input
                                    className="form-control"
                                    type="file"
                                    onBlur={(e) => setAttendanceFile(e.target.files[0])}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="attendenceMonth">
                                <Form.Label style={{ width: '100%' }}><b>Attendence Month *</b></Form.Label>
                                <DatePicker
                                    selected={selectedMonth}
                                    onChange={handleMonthChange}
                                    showMonthYearPicker
                                    dateFormat="MMMM yyyy"
                                    className="form-control"
                                    placeholderText="Select Month"
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {_.isEmpty(financialMonth) || attendanceFile == "" ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => { SaveAttendanceFile() }}> SAVE </Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
}
const mapDispatchToProps = (dispatch) => {
    return {
        UploadAttendanceFileApi: (data, showSuccessAlert, showErrorAlert) => dispatch(UploadAttendanceFileApi(data, showSuccessAlert, showErrorAlert)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isUploadingAttendanceFile: state.AttendanceReducer.isUploadingAttendanceFile,
});

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceUpload);
